const moveoImageMessage = ({ url }, avatar) =>
  `<li class="moveo__other"><img class="bot__image" src="${avatar}" /><img class="image__bubble" src="${url}"></li>`;
export default moveoImageMessage;
